import React, { Component } from "react";
import { getContentByVariationType } from "../../content/ContentDoneSimply";
import { fileDownloadRetryLinkContent } from "../../content/download/FileDownloadRetryLinkContent";
import styles from "../../assets/css/modules/download/file-download-retry-link.css";
import { Download } from "./Download";
import { Browser } from "../../features/native/NativeBrowserFeatures";
import { trackException } from "../../logging/AppInsightsLogger";

export const failedToOpenDocumentErrorMessage =
  "Failed to open file download retry link";

export class FileDownloadRetryLink extends Component {
  render() {
    const { url, urlData, fileName } = this.props;
    const content = getContentByVariationType(
      fileDownloadRetryLinkContent.variationTypes.Any,
      fileDownloadRetryLinkContent
    );

    const handleEventAndDownload = (event) => {
      event.preventDefault();
      if (Browser.doesSupportModernAnchorAttributes()) {
        Download.pdfUsingModernAnchorTag({ fileName, url });
      } else if (Browser.doesSupportMsSaveBlob()) {
        Download.pdfUsingMsSaveBlob(urlData, fileName);
      } else {
        trackException(
          failedToOpenDocumentErrorMessage,
          `Filename: ${fileName} Useragent: ${navigator.userAgent}`
        );
      }
    };

    return (
      <div className={styles.fileDownloadRetryLink}>
        <p>
          {content.retry.message}{" "}
          <button
            aria-label={`${content.retry.button.aria.label} ${fileName}`}
            onClick={(event) => handleEventAndDownload(event)}
            onTouchEnd={(event) => handleEventAndDownload(event)}
            onKeyPress={(event) => handleEventAndDownload(event)}
          >
            {content.retry.button.label}
          </button>
          .
        </p>
      </div>
    );
  }
}

export default FileDownloadRetryLink;
